import styled from "styled-components";

const BottomNavigationBarMenuItemsContainerDefaultBox = styled.div`
  padding-bottom: calc(env(safe-area-inset-bottom) + 6px);
  background-color: ${props => props.theme.colors.backgroundDark};
`;

export const BottomNavigationBarMenuItemsContainerBox = BottomNavigationBarMenuItemsContainerDefaultBox;
